export default{
    getPostFilter: state => state.filter,
    getPostList: state => state.list,
    getPostValidation: state => state.validation,
    getPostResult: state => state.result
}